<template>
  <div id="app">
    <app-header v-if="header_show"></app-header>
    <router-view v-on:header="header"></router-view>
  </div>
</template>

<script>
import Header from "./components/Header";
export default {
  name: "App",
  components: {
    "app-header": Header
  },
  data() {
    return {
      header_show: false
    };
  },
  methods: {
    header: function(bool) {
      // this.header_show = bool;
      this.id = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checkislogin",
        {
          token: this.id
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 200) {
          this.header_show = true;
        } else {
          this.header_show = bool;
        }
      });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  padding-right: 0 !important;
  min-width: 1200px;
}
body::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue